<div class="container-fluid py-4 volunteer-container">
  <!-- Detail View (when viewing a single volunteer) -->
  <div *ngIf="volunteers.length === 1 && encryptedId; else listView">
    <div class="row mb-4">
      <div class="col-12">
        <button class="btn btn-secondary" (click)="router.navigate(['/main/volunteer'])">
          <i class="bi bi-arrow-left me-2"></i>Back to Volunteers
        </button>
      </div>
    </div>

    <div class="row" *ngIf="volunteers[0]">
      <div class="col-lg-10 mx-auto">
        <div class="card shadow-lg border-0 rounded-4 glass-card">
          <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
            <h2 class="mb-0">Volunteer Details</h2>
            <button class="btn btn-sm btn-light" (click)="toggleEditMode()" *ngIf="!isEditMode">
              <i class="bi bi-pencil me-2"></i>Edit
            </button>
          </div>
          <div class="card-body p-4">
            <div *ngIf="isEditMode && editableVolunteer; else viewMode">
              <!-- Edit Mode -->
              <form>
                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Name</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.name" name="name">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Email</label>
                    <input type="email" class="form-control" [(ngModel)]="editableVolunteer.email" name="email">
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Phone</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.phone" name="phone">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Age</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.age" name="age">
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">City</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.city" name="city">
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Volunteer Role</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.volunteerRole"
                      name="volunteerRole">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Volunteer Availability</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.volunteerAvailability"
                      name="volunteerAvailability">
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Prefer Days</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.volunteerPreferDays"
                      name="volunteerPreferDays">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">School/College Name</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.schoolOrCollegeName"
                      name="schoolOrCollegeName">
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Grade/Year</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.gradeOrYear"
                      name="gradeOrYear">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Skills</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.skills" name="skills">
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Under 18</label>
                    <div class="form-check mt-2">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="editableVolunteer.under18"
                        name="under18" id="under18">
                      <label class="form-check-label" for="under18">
                        Yes
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4" *ngIf="editableVolunteer.under18">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Parent/Guardian Name</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.parentNameOrGuardianName"
                      name="parentNameOrGuardianName">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Parent/Guardian Contact</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.parentOrGuardianContact"
                      name="parentOrGuardianContact">
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <label class="form-label fw-semibold">About</label>
                    <textarea class="form-control" [(ngModel)]="editableVolunteer.about" name="about"
                      rows="3"></textarea>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="form-label fw-semibold">Service Hours</label>
                    <input type="text" class="form-control" [(ngModel)]="editableVolunteer.serviceHours"
                      name="serviceHours">
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <label class="form-label fw-semibold">Admin Upload File</label>
                    <input type="file" class="form-control" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" (change)="onResumeFileSelected($event)" id="adminFile">
                    <small class="form-text text-muted">Accepted formats: PDF, DOC, DOCX, JPG, JPEG, PNG</small>
                    <div *ngIf="resumeFile" class="mt-2 alert alert-info">
                      <i class="bi bi-file-earmark-check me-2"></i>Selected file: {{ resumeFile.name }}
                    </div>
                    <div *ngIf="(editableVolunteer.adminUploadFileData?.trim() || editableVolunteer.adminUploadPath?.trim()) && !resumeFile" class="mt-2">
                      <button type="button" class="btn btn-sm btn-info" (click)="previewUploadedFile(editableVolunteer.volunteerDetailsSeq)">
                        <i class="bi bi-eye me-2"></i>Preview Current File
                      </button>
                    </div>
                  </div>
                </div>

                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-success" (click)="saveChanges()">
                    <i class="bi bi-check-lg me-2"></i>Save Changes
                  </button>
                  <button type="button" class="btn btn-secondary" (click)="cancelEdit()">
                    <i class="bi bi-x-lg me-2"></i>Cancel
                  </button>
                </div>
              </form>
            </div>

            <ng-template #viewMode>
              <!-- View Mode -->
              <div class="row mb-4">
                <div class="col-md-6">
                  <p><strong>Name:</strong> {{ volunteers[0].name }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Email:</strong> {{ volunteers[0].email }}</p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-md-6">
                  <p><strong>Phone:</strong> {{ volunteers[0].phone }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Age:</strong> {{ volunteers[0].age }}</p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-md-6">
                  <p><strong>City:</strong> {{ volunteers[0].city || 'N/A' }}</p>
                </div>

              </div>

              <div class="row mb-4">
                <div class="col-md-6">
                  <p><strong>Volunteer Role:</strong> {{ volunteers[0].volunteerRole || 'N/A' }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Availability:</strong> {{ volunteers[0].volunteerAvailability || 'N/A' }}</p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-md-6">
                  <p><strong>Prefer Days:</strong> {{ volunteers[0].volunteerPreferDays || 'N/A' }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>School/College:</strong> {{ volunteers[0].schoolOrCollegeName || 'N/A' }}</p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-md-6">
                  <p><strong>Grade/Year:</strong> {{ volunteers[0].gradeOrYear || 'N/A' }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Skills:</strong> {{ volunteers[0].skills || 'N/A' }}</p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-md-6">
                  <p><strong>Under 18:</strong> <span class="badge"
                      [ngClass]="{ 'bg-success': volunteers[0].under18, 'bg-secondary': !volunteers[0].under18 }">{{
                      volunteers[0].under18 ? 'Yes' : 'No' }}</span></p>
                </div>
              </div>

              <div class="row mb-4" *ngIf="volunteers[0].under18">
                <div class="col-md-6">
                  <p><strong>Parent/Guardian Name:</strong> {{ volunteers[0].parentNameOrGuardianName || 'N/A' }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Parent/Guardian Contact:</strong> {{ volunteers[0].parentOrGuardianContact || 'N/A' }}</p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-12">
                  <p><strong>About:</strong></p>
                  <p class="text-muted">{{ volunteers[0].about || 'N/A' }}</p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-md-6">
                  <p><strong>Service Hours:</strong> {{ volunteers[0].serviceHours || 'N/A' }}</p>
                </div>
              </div>

              <hr class="my-4">

              <div class="row">
                <div class="col-12">
                  <label class="fw-semibold text-muted mb-3 d-block">File Downloads</label>
                  <div class="d-flex gap-3">
                    <button class="btn btn-primary" (click)="previewUploadedFile(volunteers[0].volunteerDetailsSeq)"
                      *ngIf="volunteers[0].resumePath">
                      <i class="bi bi-download me-2"></i>Download Resume
                    </button>
                    <button class="btn btn-info" (click)="downloadAdminFile(volunteers[0].volunteerDetailsSeq)"
                      *ngIf="volunteers[0].adminUploadFileData || volunteers[0].adminUploadPath">
                      <i class="bi bi-download me-2"></i>Download Admin File
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- List View -->
  <ng-template #listView>
    <div class="text-center mb-4">
      <h2 class="title">Volunteer Details</h2>
      <p class="subtitle">Overview of all registered volunteers</p>
    </div>

    <div class="card shadow-lg border-0 rounded-4 glass-card">
      <div class="table-scroll-wrapper">
        <table class="table table-hover align-middle stylish-table mb-0">
          <thead>
            <tr>
              <th class="text-center">Sr.No</th>
              <th class="text-center">Name</th>
              <th class="text-center">Email</th>
              <th class="text-center">Phone</th>
              <th class="text-center">Age</th>
              <th class="text-center">View</th>
              <th class="text-center">Volunteer File</th>
              <th class="text-center">Admin File</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let volunteer of volunteers; let i = index">
              <td class="text-center">{{ i + 1 }}</td>
              <td class="fw-semibold text-center">{{ volunteer.name }}</td>
              <td class="text-center">{{ volunteer.email }}</td>
              <td class="text-center">{{ volunteer.phone }}</td>
              <td class="text-center">{{ volunteer.age }}</td>

              <td class="text-center">
                <i class="bi bi-eye icon-action text-success" title="This volunteer Details"
                  (click)="viewVolunteer(volunteer.volunteerDetailsSeq)"></i>
              </td>

              <td class="text-center">
                <i class="bi bi-download icon-action text-success" title="This volunteer File"
                  (click)="previewUploadedFile(volunteer.volunteerDetailsSeq)"></i>
              </td>

              <td class="text-center">
                <ng-container
                  *ngIf="volunteer.adminUploadPath && volunteer.adminUploadPath.trim() !== ''; else noAdminFile">
                  <i class="bi bi-download icon-action text-success"
                    (click)="downloadAdminFile(volunteer.volunteerDetailsSeq)" title="File"></i>
                </ng-container>

                <ng-template #noAdminFile>
                  <i class="bi bi-slash-circle-fill text-muted text-center" title="No file"></i>
                </ng-template>
              </td>

            </tr>

            <tr *ngIf="volunteers.length === 0">
              <td colspan="8" class="text-center text-muted py-4">No volunteers found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-template>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>